import Layout from '@/layout/paycools-index.vue'
// import i18n from '@/lang'

export const paymentToolsRouter = {
  path: '/paymentTools',
  component: Layout ,
  name: 'paymentTools',
  redirect: '/paymentTools/staticQr',
  alwaysShow: true,
  meta: { title: 'accept_payments', icon: 'qr-code-icon' },
  children: [
    {
      path: 'staticQr',
      name: 'Static_Qr',
      component: () => import('@/views/paycools/payment-tools/static-qr'),
      meta: {
        title: 'static_qr', noCache: false,
        auth: ['AUTH_CODE_QR_STAND']
      }
    }
  ]
}

